import { useState, useEffect } from "react";
import cross from "../../images/Popup/Cross.svg";
import styles from "./CreateUserDialog.module.css";

const FormFields = [
  {
    title: "Email",
    placeholder: "Enter Email",
    type: "email",
    value: "email",
  },
  {
    title: "Password",
    placeholder: "Enter Password",
    type: "password",
    value: "password",
    editPlaceholder: "Leave blank to keep current",
  },
  {
    title: "Name",
    placeholder: "Enter Name",
    type: "text",
    value: "name",
  },
  {
    title: "Company Name",
    placeholder: "Enter Company Name",
    type: "text",
    value: "companyName",
  },
  {
    title: "Phone",
    placeholder: "Enter Phone Number",
    type: "tel",
    value: "phone",
  },
];

export const CreateEditUserDialog = ({
  show,
  onClose,
  onSubmit,
  isEditing = false,
  initialData = null,
}) => {
  const [formFields, setFormFields] = useState({
    email: "",
    password: "",
    name: "",
    companyName: "",
    phone: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (show && isEditing && initialData) {
      setFormFields({
        email: initialData.email ?? "",
        password: "",
        name: initialData.name ?? "",
        companyName: initialData.companyName ?? "",
        phone: initialData.phone ?? "",
      });
    } else if (show && !isEditing) {
      setFormFields({
        email: "",
        password: "",
        name: "",
        companyName: "",
        phone: "",
      });
    }
  }, [show, isEditing, initialData]);

  const handleChange = (field, value) => {
    setFormFields((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (formFields.email && !/\S+@\S+\.\S+/.test(formFields.email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (
      formFields.password &&
      formFields.password.trim() !== "" &&
      formFields.password.length < 6
    ) {
      newErrors.password = "Password must be at least 6 characters";
    }

    if (!formFields.name || formFields.name.trim() === "") {
      newErrors.name = "Name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleConfirm = async () => {
    setSubmitted(true);

    if (!validateForm()) {
      return;
    }

    if (onSubmit) {
      await onSubmit(formFields);
    }

    setFormFields({
      email: "",
      password: "",
      name: "",
      companyName: "",
      phone: "",
    });
    setSubmitted(false);
    setErrors({});
    onClose();
  };

  const handleClose = () => {
    setFormFields({
      email: "",
      password: "",
      name: "",
      companyName: "",
      phone: "",
    });
    setSubmitted(false);
    setErrors({});
    onClose();
  };

  if (!show) return null;

  return (
    <div>
      <div className={styles.Backdrop} onClick={handleClose}></div>
      <div className={styles.popup}>
        <div className={styles.cross}>
          <img src={cross} alt="Close" onClick={handleClose} />
        </div>
        <div className={styles.formContainer}>
          <div className={styles.heading}>
            {isEditing ? "Edit User" : "Create New User"}
          </div>
          {FormFields.map((field) => (
            <div key={field.value} className={styles.fieldWrapper}>
              <div className={styles.fieldContainer}>
                <div className={styles.field}>{field.title}:</div>
                <input
                  className={`${styles.input} ${
                    errors[field.value] && submitted ? styles.inputError : ""
                  }`}
                  name={field.value}
                  value={formFields[field.value]}
                  onChange={(e) => handleChange(field.value, e.target.value)}
                  placeholder={
                    isEditing && field.editPlaceholder
                      ? field.editPlaceholder
                      : field.placeholder
                  }
                  type={field.type}
                />
              </div>
              {errors[field.value] && submitted && (
                <div className={styles.errorMessage}>{errors[field.value]}</div>
              )}
            </div>
          ))}
          <button className={styles.confirmButton} onClick={handleConfirm}>
            {isEditing ? "Update" : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
};
